import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";

import { SummarizeReviewModule } from "../../../../components/AIModules/SummarizeReview";

import { useFeatureFlagQuery } from "../../../../hooks/useFeatureFlag";

type Props = {
	elementId: string;
};

const AISummaryPortal = ({ elementId }: Props) => {
	const { value: aiFeatureFlagEnabled } = useFeatureFlagQuery("ff-is-ai-enabled", false);
	const targetElement = document.getElementById(elementId);
	if (!targetElement) return null;

	const [isOpen, setIsOpen] = useState(false);
	const [reviewId, setReviewId] = useState(targetElement?.getAttribute("data-review-id") || "");

	// **Event Delegation: Listen for clicks anywhere on the document**
	useEffect(() => {
		const handleClick = (event: Event) => {
			const target = event.target as HTMLElement;
			const summarizeButton = target.closest(".js-summarize-review-button");
			if (summarizeButton) {
				const clickedReviewId = summarizeButton.getAttribute("data-review-id");
				if (clickedReviewId) {
					setReviewId(clickedReviewId);
					setIsOpen(true);
				}
			}
		};
		targetElement.addEventListener("click", handleClick);
	}, []);

	const content = isOpen ? (
		<div
			style={{
				width: "100%",
				display: "flex",
				justifyContent: "left",
				alignItems: "left",
				paddingTop: 8,
			}}
		>
			<SummarizeReviewModule reviewId={reviewId} isOpen={isOpen} onOpenChange={setIsOpen} />
		</div>
	) : null;

	//attach portal to root element
	if (aiFeatureFlagEnabled && targetElement) {
		return ReactDOM.createPortal(content, targetElement);
	}

	return null;
};

export default AISummaryPortal;
